/**
 * Amber-Style Color Swatches
 * Handles swatch selection and variant updates
 */

class AmberSwatches {
    constructor() {
        this.init();
    }

    init() {
        // Initialize all swatch containers
        document.querySelectorAll('.amber-swatches').forEach(container => {
            this.setupSwatchContainer(container);
        });
    }

    setupSwatchContainer(container) {
        const swatches = container.querySelectorAll('.amber-swatch');
        const selectedValueDisplay = container.querySelector('[data-selected-swatch-value]');

        swatches.forEach(swatch => {
            const input = swatch.querySelector('.amber-swatch__input');
            const label = swatch.querySelector('.amber-swatch__label');

            // Handle click on swatch
            label.addEventListener('click', (e) => {
                if (swatch.classList.contains('amber-swatch--unavailable')) {
                    e.preventDefault();
                    return;
                }

                // Update selected state
                this.selectSwatch(container, swatch, selectedValueDisplay);
            });

            // Handle keyboard navigation
            input.addEventListener('change', () => {
                this.selectSwatch(container, swatch, selectedValueDisplay);
            });
        });
    }

    selectSwatch(container, selectedSwatch, valueDisplay) {
        const value = selectedSwatch.dataset.swatchValue;

        // Remove selected state from all swatches in this container
        container.querySelectorAll('.amber-swatch').forEach(s => {
            s.classList.remove('amber-swatch--selected');
        });

        // Add selected state to clicked swatch
        selectedSwatch.classList.add('amber-swatch--selected');

        // Update the displayed value
        if (valueDisplay) {
            valueDisplay.textContent = value;
        }

        // Trigger variant change for Dawn theme
        this.triggerVariantChange(selectedSwatch);
    }

    triggerVariantChange(swatch) {
        const input = swatch.querySelector('.amber-swatch__input');

        if (input) {
            // Check the radio input
            input.checked = true;

            // Dispatch change event for variant-selects custom element
            const variantSelects = input.closest('variant-selects');
            if (variantSelects) {
                variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // Also dispatch on the input itself
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new AmberSwatches());
} else {
    new AmberSwatches();
}

// Re-initialize after AJAX loads (for quick view modals, etc.)
document.addEventListener('shopify:section:load', () => new AmberSwatches());
